import React, { Component } from 'react';
import FormDetails from './FormDetails';
import PatientInformation from './PatientInformation';

import { connect } from 'react-redux';
import { formService } from '../../../_services/form.service';
import { alertActions } from '../../../_actions/alert.actions';
import httpStatus from 'http-status';

class SendForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      formId: "",
      chartId: "",
      otherId: "",
      groupId: "",
      lastName: "",
      firstName: "",
      providerId: "",
      availableOn: "",
      dateOfBirth: "",
      currentStep: 'PATIENT_INFORMATION',
      cellPhoneNumber: "",
      completeByDate: "",
      isSaving: false
    }

    this.handleSetState = this.handleSetState.bind(this);
    this.handleNextStep = this.handleNextStep.bind(this);
    this.handleBackStep = this.handleBackStep.bind(this);
    this.handleSaveForm = this.handleSaveForm.bind(this);
  }

  handleSetState(name, value) {
    this.setState({ [name]: value })
  }

  handleNextStep() {
    let nextStep;

    switch (this.state.currentStep) {
      case 'PATIENT_INFORMATION':
        nextStep = 'FORM_DETAILS';
        break;
      default:
        return false;
    }

    this.setState({ currentStep: nextStep });
  }

  handleBackStep() {
    let nextStep;

    switch (this.state.currentStep) {
      case 'FORM_DETAILS':
        nextStep = 'PATIENT_INFORMATION';
        break;
      default:
        return false;
    }

    this.setState({ currentStep: nextStep });
  }

  handleSaveForm() {
    this.setState({ isSaving: true });

    formService.sendForm(this.state)
      .then(() => {
        this.setState({ isSaving: false });
        this.props.history.push('/forms');
        this.props.dispatch(alertActions.success('The form has been sent!'));
      })
      .catch(error => {
        this.setState({ isSaving: false });

        if (error.response && error.response.status === httpStatus.FORBIDDEN ) {
          this.props.dispatch(alertActions.error("You don't have permission to perform this action."));
        } else {
          this.props.dispatch(alertActions.error('Could not send the form at this time. Please try again later.'));
        }
      });
  }

  render() {
    const { currentStep } = this.state;

    return (
      <div className="row">
        <div className="col-lg-12">
          <PatientInformation
            nextStep={this.handleNextStep}
            setValue={this.handleSetState}
            currentStep={currentStep}
            email={this.state.email}
            chartId={this.state.chartId}
            otherId={this.state.otherId}
            lastName={this.state.lastName}
            firstName={this.state.firstName}
            dateOfBirth={this.state.dateOfBirth}
            cellPhoneNumber={this.state.cellPhoneNumber}
          />
        </div>

        <div className="col-lg-12">
          <FormDetails
            isSaving={this.state.isSaving}
            saveForm={this.handleSaveForm}
            nextStep={this.handleNextStep}
            backStep={this.handleBackStep}
            setValue={this.handleSetState}
            currentStep={currentStep}
            formId={this.state.formId}
            groupId={this.state.groupId}
            providerId={this.state.providerId}
            availableOn={this.state.availableOn}
            completeByDate={this.state.completeByDate}
          />
        </div>
      </div>
    )
  }
}

export default connect()(SendForm);